<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span> ข้อมูลการประกอบการ/ศักยภาพความพร้อม <span
            class="theme-color-seven txt-normal">(ถ้ามี)</span>
        </div>

        <!-- Form 1 -->
        <div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">เลขทะเบียน นิติบุคคล/ทะเบียนการค้า (ถ้ามี)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_reg_no"
                  @onChange="setFormField('p2_reg_no', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">วิสาหกิจชุมชน (ถ้ามี)</div>
              <TextField
                  theme="3"
                  :value="form.p2_comm_ent"
                  @onChange="setFormField('p2_comm_ent', $event)"
              ></TextField>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">OTOP (ถ้ามี)</div>
              <TextField
                  theme="3"
                  :value="form.p2_otop"
                  @onChange="setFormField('p2_otop', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">อื่น ๆ โปรดระบุ</div>
              <TextField
                  theme="3"
                  :value="form.p2_reg_other"
                  @onChange="setFormField('p2_reg_other', $event)"
              ></TextField>
            </div>
          </div>
        </div>

      </div>

      <div class="card-part">
        <!-- Form 2 -->
        <div>
          <!-- Form 2 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex xs6">
              <div class="mb-1 black--text">ทุนจดทะเบียน/การระดมหุ้น (บาท)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_reg_cap"
                  @onChange="setFormField('p2_reg_cap', $event)"
              ></TextField>
            </div>

            <div class="flex xs6">
              <div class="mb-1 black--text">คนไทยถือหุ้นร้อยละ</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_thai_share_pct"
                  @onChange="setFormField('p2_thai_share_pct', $event)"
              ></TextField>
            </div>
          </div>

          <!-- Form 2 #line2 -->
          <div class="flex-center gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">ปีที่จดทะเบียน (พ.ศ.)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_reg_year"
                  @onChange="setFormField('p2_reg_year', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">ปีที่ก่อตั้ง (พ.ศ.)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_est_year"
                  @onChange="setFormField('p2_est_year', $event)"
              ></TextField>
            </div>

            <div class="flex xs4">
              <div class="mb-1 black--text">จำนวนพนักงาน/สมาชิก (คน)</div>
              <TextField
                  theme="3"
                  input-type="number"
                  :value="form.p2_emp_count"
                  @onChange="setFormField('p2_emp_count', $event)"
              ></TextField>
            </div>
          </div>

        </div>
      </div>

      <div class="card-part">
        <!-- Form 3 -->
        <div>
          <!-- Form 3 #line1 -->
          <div class="d-flex gap-16">
            <div class="flex xs4">
              <div class="mb-1 black--text">การจดทะเบียนทรัพย์สินทางปัญญา</div>
            </div>

            <v-radio-group
                class="mt-0 pt-0"
                :value="form.p2_ip_status"
                @change="setFormField('p2_ip_status', $event)"
            >
            <div class="flex">
              <RadioItem class="mb-3" value="0">
                <div class="black--text">
                  ยังไม่ได้ยื่นจดทะเบียน
                </div>
              </RadioItem>
<!--              <CheckBox-->
<!--                  class="mb-3"-->
<!--                  value="1"-->
<!--                  :input-value="form.p2_ip_status"-->
<!--                  @onChange="setFormField('p2_ip_status', $event)"-->
<!--              >-->
<!--                ยังไม่ได้ยื่นจดทะเบียน-->
<!--              </CheckBox>-->

              <div class="d-flex justify-space-between gap-12">
                <div class="flex xs6">
                  <RadioItem class="mb-2" value="1">
                    <div class="black--text">
                      ได้รับแล้ว
                    </div>
                  </RadioItem>
                  <AutoBox
                      theme="3"
                      disabled=""
                      :items="masterData.ip_type"
                      item-text="name"
                      item-value="name"
                      :value="form.p2_ip_type"
                      @onChange="setFormField('p2_ip_type', $event)"
                  ></AutoBox>
                </div>

                <div class="flex xs6">
                  <div class="mb-2 black--text">เลขที่</div>
                  <TextField
                      theme="3"
                      :value="form.p2_ip_no"
                      @onChange="setFormField('p2_ip_no', $event)"
                  ></TextField>
                </div>
              </div>
            </div>
            </v-radio-group>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 4 -->
        <div>
          <v-radio-group
              class="mt-0 pt-0"
              :value="form.p2_has_prod"
              @change="setFormField('p2_has_prod', $event)"
          >
          <!-- Form 4 #line1 -->
          <div class="d-flex justify-space-between gap-16">
            <div class="flex xs4">
              <RadioItem class="mb-2" value="0">
                <div class="black--text">
                  ยังไม่ได้ผลิตภัณฑ์ผลิตและจำหน่าย
                </div>
              </RadioItem>
            </div>

            <div class="flex">
              <AutoBox
                  theme="3"
                  :items="masterData.prod_idea"
                  item-text="name"
                  item-value="name"
                  :value="form.p2_prod_idea"
                  @onChange="setFormField('p2_prod_idea', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 4 #line2 -->
          <div class="d-flex justify-space-between gap-16">
            <div class="flex xs4">
              <RadioItem class="mb-2" value="1">
                <div class="black--text">
                  มีผลิตภัณฑ์ผลิตและจำหน่ายแล้ว
                </div>
              </RadioItem>
            </div>

            <div class="flex d-flex justify-space-between gap-12">
              <div class="flex xs6">
                <div class="mb-1 black--text">
                  ผลิตภัณฑ์ ได้แก่
                </div>
                <TextArea
                    theme="3"
                    :value="form.p2_prod_name"
                    @onChange="setFormField('p2_prod_name', $event)"
                ></TextArea>
              </div>

              <div class="flex xs6">
                <div class="mb-1 black--text">
                  มาตรฐานคุณภาพที่ได้รับ
                </div>
                <TextArea
                    theme="3"
                    :value="form.p2_prod_qc"
                    @onChange="setFormField('p2_prod_qc', $event)"
                ></TextArea>
              </div>
            </div>
          </div>
          </v-radio-group>
        </div>
      </div>

      <div class="card-part">
        <div>
          <div class="mb-1 black--text">
            ผลงานที่ผ่านมา
          </div>
          <TextArea
              theme="3"
              height="148"
              :value="form.p2_past_works"
              @onChange="setFormField('p2_past_works', $event)"
          ></TextArea>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import TextArea from "../../components/input/TextArea"
import AutoBox from "../../components/input/AutoBox"
import RadioItem from "../../components/input/RadioItem"
import { mapState } from "vuex"
import { eventBus } from "../../plugins/global-funcs"

export default {
  name: "FormBusiness",
  components: {
    TextField,
    TextArea,
    AutoBox,
    RadioItem
  },
  props: {
    masterData: Object,
    formData: Object
  },
  data () {
    return {
      form: {}
    }
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      BusinessForm: state => state.Requirement.BusinessForm
    })
  },
  created () {
    this.form = JSON.parse(JSON.stringify(this.formData))
    eventBus.$on('requirementFormBusiness', () => {
      eventBus.$emit('requirementFormBusinessSend', this.form)
    })
    eventBus.$emit('requirementFormGeneralSend', this.form)
  },
  methods: {
    setFormField (field, val) {
      this.form[field] = val
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>

</style>